import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/authStore'
import LoginPage from '@/pages/LoginPage.vue'
import DashboardPage from '@/pages/DashboardPage.vue'
import DistrictsPage from '@/pages/masters/DistrictsPage.vue'
import VehiclesPage from '@/pages/masters/VehiclesPage.vue'
import StaffPage from '@/pages/masters/StaffPage.vue'
import DoctorsPage from '@/pages/masters/DoctorsPage.vue'
import ColoursPage from '@/pages/masters/ColoursPage.vue'
import StatusesPage from '@/pages/masters/StatusesPage.vue'
import PostSurgeryLocationsPage from '@/pages/masters/PostSurgeryLocationsPage.vue'
import SurgeonsPage from '@/pages/masters/SurgeonsPage.vue'
import MedicinesPage from '@/pages/masters/MedicinesPage.vue'
import ProfilePage from '@/pages/ProfilePage.vue'
import CatchingsPage from '@/pages/operations/CatchingsPage.vue'
import CatchingFormPage from '@/pages/operations/CatchingFormPage.vue'
import CatchingDetailPage from '@/pages/operations/CatchingDetailPage.vue'
import NotFoundPage from '@/pages/NotFoundPage.vue'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
    meta: { requiresAuth: false, layout: 'minimal' }
  },
  {
    path: '/',
    name: 'Dashboard',
    component: DashboardPage,
    meta: { requiresAuth: true, layout: 'default' }
  },
  {
    path: '/settings/districts',
    name: 'Districts',
    component: DistrictsPage,
    meta: { requiresAuth: true, layout: 'default', adminOnly: true }
  },
  {
    path: '/settings/vehicles',
    name: 'Vehicles',
    component: VehiclesPage,
    meta: { requiresAuth: true, layout: 'default' }
  },
  {
    path: '/masters/staff',
    name: 'Staff',
    component: StaffPage,
    meta: { requiresAuth: true, layout: 'default' }
  },
  {
    path: '/masters/doctors',
    name: 'Doctors',
    component: DoctorsPage,
    meta: { requiresAuth: true, layout: 'default', adminOnly: true }
  },
  {
    path: '/settings/colours',
    name: 'Colours',
    component: ColoursPage,
    meta: { requiresAuth: true, layout: 'default', adminOnly: true }
  },
  {
    path: '/settings/statuses',
    name: 'Statuses',
    component: StatusesPage,
    meta: { requiresAuth: true, layout: 'default', adminOnly: true }
  },
  {
    path: '/settings/post-surgery-locations',
    name: 'PostSurgeryLocations',
    component: PostSurgeryLocationsPage,
    meta: { requiresAuth: true, layout: 'default', adminOnly: true }
  },
  {
    path: '/masters/surgeons',
    name: 'Surgeons',
    component: SurgeonsPage,
    meta: { requiresAuth: true, layout: 'default', adminOnly: true }
  },
  {
    path: '/masters/medicines',
    name: 'Medicines',
    component: MedicinesPage,
    meta: { requiresAuth: true, layout: 'default', adminOnly: true }
  },
  {
    path: '/operations/catchings',
    name: 'Catchings',
    component: CatchingsPage,
    meta: { requiresAuth: true, layout: 'default' }
  },
  {
    path: '/operations/catchings/new',
    name: 'NewCatching',
    component: CatchingFormPage,
    meta: { requiresAuth: true, layout: 'default' }
  },
  {
    path: '/operations/catchings/:id/edit',
    name: 'EditCatching',
    component: CatchingFormPage,
    meta: { requiresAuth: true, layout: 'default' }
  },
  {
    path: '/operations/catchings/:id',
    name: 'CatchingDetail',
    component: CatchingDetailPage,
    meta: { requiresAuth: true, layout: 'default' }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfilePage,
    meta: { requiresAuth: true, layout: 'default' }
  },
  {
    path: '/masters/districts',
    redirect: '/settings/districts'
  },
  {
    path: '/masters/vehicles',
    redirect: '/settings/vehicles'
  },
  {
    path: '/masters/colours',
    redirect: '/settings/colours'
  },
  {
    path: '/masters/statuses',
    redirect: '/settings/statuses'
  },
  {
    path: '/masters/post-surgery-locations',
    redirect: '/settings/post-surgery-locations'
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundPage,
    meta: { layout: 'minimal' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Global navigation guard
router.beforeEach((to, from, next) => {
  const authStore = useAuthStore()
  
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    next({ name: 'Login' })
  } else if (to.meta.adminOnly && !authStore.isAdmin) {
    next({ name: 'Dashboard' })
  } else if (to.name === 'Login' && authStore.isAuthenticated) {
    next({ name: 'Dashboard' })
  } else {
    next()
  }
})

export default router
